'use strict';

function CreditCheck() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_AccountController, _AnalyticsData];
  this._onCreditCheckCallback = null;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();

    // Skip to Next Step or bounce back
    if (this.hasDoneCreditCheck() || !this.hasAllProfileInfo() || !this.hasProvidedConsent()) {
      this.routeToNextStep();
      return;
    }

    this.analytics.pushEvent('virtual-page-view');
    this._creditCheck();
  };

  this._creditCheck = function () {
    this._onCreditCheckCallback = this.presenter.addCallbackToAction('account.get_credit_detail', $.proxy(this._onCreditCheck, this));
    this.presenter.performAction('account.get_credit_detail');
  };

  this._onCreditCheck = function (data, response) {
    if (data.errors) {
      this.analytics.forcePushEvent('generic-api-response-error', {
        event: ['KYCPartnerResponseError'],
        Code: [data.errors[0].code],
        Key: [data.errors[0].key],
        Msg: [data.errors[0].msg],
        Property: [data.errors[0].property]
      });
    }

    if (response === 400 && data.errors[0].key === 'member_service_duplicated_account_error') {
      // Credit check has matched an existing account to the same UUID
      // User is asked to login with pre-existing account (email address) instead
      // NOTE: backend has already deleted the new user account at this point.
      // ... can use lastname stub s-s-s-s-g-l-two-f to test this case
      this.presenter.models.account.setModelProperty('existing_account_uuid', data.errors[0].existing_account_uuid);
      this.presenter.models.account.setModelProperty('existing_account_email_address', data.errors[0].existing_account_email_address);
      this.presenter.models.account.setModelProperty('previous_session', data.errors[0].previous_session);
      this.history.goToUrl(this.paths.signup.account_already_exists);
    } else if (response === 503 && data.errors[0].key === 'retry') {
      // Equifax Partner Down (devOps has flipped switch disabling the credit_check feature)
      // prop used later as an guard from hitting the end point twice.
      this.presenter.models.account.setModelProperty('kyc_decision', 'credit_check_partner_down');
      this.history.goToUrl(this.paths.signup.kyc_partner_down);
    } else if (response === 500 && data.errors[0].key === 'equifax_remote_service_error') {
      this.handleDeclinedState(data, response); // takes users to unrecoverable_error page
    } else if (this.isGeneralConnectionIssue(data, response)) {
      // Handle Timeouts:
      //       "code": 504,
      //       "key": "equifax_service_net_read_timeout",
      this.invokeConnectionIssuePage({ action: 'account.get_credit_detail' }, { productLabel: 'MogoMember' });
    } else if (response === 200) {
      // Success Case
      this.analytics.pushEvent('identity-verified');

      if (data.approved_products) {
        this.analytics.forcePushEvent('money-approval', {
          ProductApproved: [data],
          AmountApproved: [data.approved_products],
          Lender: [data.approved_products]
        });
      }

      $('#Portal').mogo().pushProductsOfInterestAnalytics();

      this.presenter.models.account.updateModel(null, this._onCompleteCreditCheck.bind(this, data));
    } else {
      // Unexpected Case
      $('#Notification').mogo().get();

      try {
        FS.event('Mogo App Debug', {
          name: 'Unexpected credit check response'
        });
      } catch (e) {}

      // TODO: we'll want to handle users missing employment info (more likely we stop them from ever trying credit check in the first place)
      console.warn('CreditCheck: uncaught error for get_credit_detail action.');
    }
  };

  this._onCompleteCreditCheck = function (data) {
    this._routeUserIntoPortal(data);

    this.analytics.pushEvent('login-account-data', {
      UUID: [this.presenter.models.account.uuid],
      AccountCreationDate: [this.presenter.models.account.created_at],
      MemberCreationDate: [this.presenter.models.account.profile_completed_at],
      LTV: [this.presenter.models.account.life_time_value]
    });
  };

  this._routeUserIntoPortal = function (data) {
    // Route to any special case pages, else member dashboard:

    if (this.presenter.models.account.verification_level === 4) {
      // lvl 4 go to full stop no access page
      this.history.goToUrl(this.paths.signup.declined.kyc_denied);
    } else if (this._isLoanOfferCustomer(data)) {
      this._session.setSessionCookie('is_credit_seeker', 'true'); // cookie skips interstitial screen
      // special people go straight to loan offer dashboard
      this.history.goToUrl(this.paths.loans.preapproval);
      // } else if (this._isCardLead(data)) {
      //   // special people go straight to card dashboard
      //   this.history.goToUrl(this.paths.card.dashboard);
      //   this.presenter.scanDOM('#main-nav');
    } else {
      this.routeToNextStep();
    }

    // Remove theme for layout class
    $('#Portal').mogo().removeTargetAudience();
  };

  this._isCardLead = function (data) {
    return data.eligibility.card === true;
  };

  this.destroy = function () {
    this.presenter.removeCallbackFromAction('account.get_credit_detail', this._onCreditCheckCallback);
  };
}